<div *ngIf="!modalData.modalForm; else notShow" style="position: relative;" id="modal-content-wrapper" [ngClass]="customerClass">
    <header id="modal-header">
        <h1 id="modal-title" tabindex="-1" cdkFocusInitial>{{ modalData.title | translate }}</h1>
    </header>
    <section id="modal-body">
        <p>{{ modalData.description | translate }}</p>
    </section>
    <footer id="modal-footer">
        <button *ngIf="modalData.actions" color="warn" class="btn-stroked dhl-button modal-buttons" id="modal-action-button"
            (click)="actionFunction()">
            {{ modalData.actionButtonText | translate }}
        </button>
        <button *ngIf="modalData.name !=='quotationSearch'" color="warn" class="btn-raised dhl-button modal-buttons" id="modal-cancel-button" (click)="closeModal()">
            {{modalData.actionbuttonclosetext | translate }}
        </button>
        <button *ngIf="modalData.name ==='quotationSearch'"  class="dhl-button-ok modal-buttons"  (click)="closeModal()">
            {{enum.BUTTONS.BUTTONOK | translate }}
        </button>
    </footer>
</div>

<ng-template #notShow>
    <div style="position: relative;" id="modal-content-wrapper" [ngClass]="customerClass">
    <div *ngIf="modalData.modalForm.modalName === 'shipmentModalForm' ">
        <!-- <app-app-shipment-form [config]="config" [shipmentForm]="formGroup"></app-app-shipment-form> -->
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial> Shipping Unit </h1>
        </header>
        <section id="modal-body">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.controls" [ngClass]="getColsClass(control.cols)">
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                    </div>
                </div>
            </div>
        </section>
        <footer id="modal-footer" style="text-align: right;">
            <button style="margin-right: 20px;" color="warn" class="btn-stroked dhl-button modal-buttons"
                id="modal-cancel-button" (click)="CancelShipment()">
                Cancel
            </button>
            <button [disabled]="(formGroup.status === 'DISABLED')" color="warn"
                style="margin-right: 0;" class="btn-raised dhl-button modal-buttons" id="modal-action-button"
                (click)="saveShipmentDetails($event)">
                Save
            </button>
        </footer>
    </div>
    <div *ngIf="modalData.modalForm.modalName === 'filterModalForm' ">

        <div [formGroup]="formGroup">
            <div [formArrayName]="config.name" fxFlex class="mat-table mat-elevation-z0">
                <div *ngFor="let row of getFormTableControls(); let rowIndex = index" class="row mat-row">
                    <div fxFlex="calc(100%-85px)">
                        <div class="row" style="margin: 0;">
                            <div *ngFor="let control of config.controls" [formGroupName]="rowIndex"
                                [ngClass]="getColsClass(control.cols)">
                                <app-form-field [configData]="control" [frmGroup]="getFormTableControls()[rowIndex]">
                                </app-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer id="modal-footer" style="text-align: right;">
            <button style="margin-right: 25px;" color="warn" class="btn-raised dhl-button modal-buttons"
                id="modal-cancel-button" (click)="closeModal()">
                Cancel
            </button>
            <button color="warn" class="btn-stroked dhl-button modal-buttons" id="modal-action-button"
                (click)="actionFunction()">
                Search
            </button>
        </footer>
    </div>
    <div *ngIf="modalData.modalForm.modalName === 'addUserModalForm'">
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial>{{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <section *ngFor="let configGroup of config">
                <div [formGroup]="formGroup" fxFlex>
                    <div class="row">
                        <div *ngFor="let control of configGroup.controls" [ngClass]="getColsClass(control.cols)" [hidden]="control.hidden">
                            <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                        </div>
                    </div>
                </div>
            </section>           
        </section>
        
        <footer id="modal-footer" style="text-align: right;">
            <button style="margin-right: 25px;" color="warn" class="btn-stroked dhl-button modal-buttons"
                id="modal-cancel-button" (click)="closeModal()">
                Cancel
            </button>
            <button color="warn" class="btn-raised dhl-button modal-buttons" style="margin-right: 0;" id="modal-action-button"
                (click)="saveAddNewUser($event)">
                Save
            </button>
        </footer>
    </div>
    <div *ngIf="modalData.modalForm.modalName === 'editUserModalForm' ">
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial> Edit user subsciption</h1>
        </header>
        <section id="modal-body">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.controls" [ngClass]="getColsClass(control.cols)">
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                    </div>
                </div>
            </div>
        </section>
        <footer id="modal-footer" style="text-align: right;">
            <button style="margin-right: 25px;"  color="warn" class="btn-stroked dhl-button modal-buttons"
                id="modal-cancel-button" (click)="closeModal()">
                Cancel
            </button>
            <button color="warn" class="btn-raised modal-buttons" style="margin-right: 0;" id="modal-action-button"
                (click)="savUsertDetails($event)">
                Update
            </button>
        </footer>
    </div>
    <div *ngIf="modalData.modalForm.type === 'common' ">
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial> {{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.controls" [ngClass]="getColsClass(control.cols)">
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                    </div>
                </div>
            </div>
        </section>
        <footer id="modal-footer" style="text-align: right;">
            <ng-container *ngIf="config.actions; else defaultFooter">
                <ng-container *ngFor="let action of config.actions">
                    <button style=" margin-top:25px;" color="warn" class="btn-raised dhl-button modal-buttons"
                        id="modal-cancel-button" (click)="onCloseModalEvent('cancel', formGroup, modalData)">
                        {{action.view.label}}
                    </button>
                </ng-container>
            </ng-container>
        </footer>
        <ng-template id="modal-footer" style="text-align: right;" #defaultFooter>
            <button style="margin-right: 25px;"  color="warn" class="btn-stroked modal-buttons"
                id="modal-cancel-button" (click)="onCloseModalEvent('cancel', formGroup, modalData)">
                Cancel
            </button>
            <button btn-raised color="warn" class="btn-raised dhl-button modal-buttons" style="margin-right: 0;" id="modal-action-button"
                (click)="onSubmitEvent('submit', formGroup, modalData)" [disabled]="disableDefaultSaveButton ? formGroup.invalid : false">
                Save
            </button>
        </ng-template>
    </div>
    <div *ngIf="modalData.modalForm.type === 'customTextModal' ">

        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial>{{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <p>{{ modalData.description }}</p>
        </section>
        <footer id="modal-footer">

            <button *ngIf="modalData.actions" color="warn" class="btn-raised dhl-button modal-buttons"
                id="modal-action-button-cancel-order" (click)="actionFunction()">
                {{ modalData.actionButtonActionText }}
            </button>

            <button  *ngIf="modalData.actions" color="warn" class="btn-stroked dhl-button modal-buttons" id="modal-cancel-button-cancel-order"
            (click)="closeModal()">
                {{ modalData.actionButtonDismissText }}
            </button>

            <button  *ngIf="!modalData.actions" color="warn" class="btn-raised dhl-button modal-buttons" id="modal-cancel-button-cancel-order"
            (click)="closeModal()">
                {{ modalData.actionButtonDismissText }}
            </button>


        </footer>
    </div>

    <div *ngIf="modalData.modalForm.modalName === 'commonActionsModal' ">
        <header id="modal-header">
            <h1 id="modal-title" class="title" tabindex="-1" cdkFocusInitial> {{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.controls" [ngClass]="getColsClass(control.cols)">
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                    </div>
                </div>
            </div>
        </section>
        <footer id="modal-footer" style="text-align: right;">
            <ng-container *ngIf="config.actions; else defaultFooter">
                <ng-container *ngFor="let action of config.actions">
                    <button style=" margin-top:25px;" class="dhl-button modal-buttons"
                    [disabled]=" action.type === 'submit' ? (formGroup.pristine && formGroup.untouched) || formGroup.invalid : false"
                       [ngClass]="'dhl-button-' + action.view.buttonType" (click)="onCloseModalEvent(action.type, formGroup, modalData)">
                        {{action.view.label}}
                    </button>
                </ng-container>
            </ng-container>
        </footer>
        <ng-template id="modal-footer" style="text-align: right;" #defaultFooter>
            <button style="margin-right: 25px;" class="buttons-secondary modal-buttons"
                id="modal-cancel-button" (click)="onCloseModalEvent('cancel', formGroup, modalData)">
                Cancel
            </button>
            <button class="buttons-primary modal-buttons" style="margin-right: 0;" id="modal-action-button"
                (click)="onSubmitEvent('submit', formGroup, modalData)">
                Save
            </button>
        </ng-template>
    </div>

    <div *ngIf="modalData.modalForm.modalName === 'newFilterSearchModal' " class="newFilterModal">
        <header id="modal-header">
            <h1 id="modal-title" class="title" tabindex="-1" cdkFocusInitial style="font-size: 18px,"> {{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <div [formGroup]="formGroup" fxFlex>
                <div class="row">
                    <div *ngFor="let control of config.controls;let i=index" [ngClass]="getColsClass(control.cols)">
                        <div *ngIf="control.sublabel" class="dhl-sublabel">{{control.sublabel}}</div>
                        <app-form-field [configData]="control" [frmGroup]="formGroup"></app-form-field>
                        <div class="custom-line" *ngIf="i != config.controls.length - 1"><span>OR</span></div> 
                    </div>
                </div>
            </div>
        </section>
        <div *ngIf="isValueExist" style="color: #d0021b;">The name of this search already exists in your list</div>
        <div *ngIf="isErrorMessage" style="color: #d0021b;">Please, select a name for your search</div>
        <footer  id="modal-footer" style="text-align: right;">
            <ng-container *ngIf="config.actions; else defaultFooter">
                <ng-container *ngFor="let action of config.actions">
                    <button style=" margin-top:25px;" class="dhl-button modal-buttons"
                    [disabled]=" action.type === 'save' ? (formGroup.pristine) || formGroup.invalid : false"
                       [ngClass]="'dhl-button-' + action.view.buttonType" (click)="onCloseFilterModal(action.type, formGroup, modalData)">
                        {{action.view.label}}
                    </button>
                </ng-container>
            </ng-container>
        </footer>
        <ng-template id="modal-footer" style="text-align: right;" #defaultFooter>
            <button style="margin-right: 25px;" class="buttons-secondary modal-buttons"
                id="modal-cancel-button" (click)="onCloseModalEvent('cancel', formGroup, modalData)">
                Cancel
            </button>
            <button class="buttons-primary modal-buttons" style="margin-right: 0;" id="modal-action-button"
                (click)="onSubmitEvent('submit', formGroup, modalData)">
                Save
            </button>
        </ng-template>
    </div>
 
    <div *ngIf="modalData.modalForm.modalName === 'cancelOrderMessageWithReason' ">
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial>{{ modalData.title | translate }}</h1>
        </header>
        <section id="modal-body">
            <p>{{ modalData.description | translate }}</p>
        </section>
        <footer id="modal-footer" style="text-align: right;">
            <button  class="buttons-primary btn-raised modal-buttons" id="modal-cancel-button" (click)="closeModal()">
                {{enum.BUTTONS.BUTTONBACK | translate }}
            </button>
            <button *ngIf="modalData.actions" class="buttons-secondary btn-stroked modal-buttons" id="modal-action-button"
                (click)="onSubmitEventCancelOrderFn('submit', modalData)">
                {{enum.BUTTONS.BUTTONCONFIRM | translate }}
            </button>
        </footer>
    </div>
    <div *ngIf="modalData.modalForm.modalName === 'preambleMsg'">
        <header id="modal-header">
            <h1 id="modal-title" tabindex="-1" cdkFocusInitial>{{ modalData.title }}</h1>
        </header>
        <section id="modal-body">
            <p [innerHTML]="$safeNavigationMigration(modalData?.description) | safeHtml"></p>
        </section>
        <footer id="modal-footer" style="text-align: right;" *ngIf="modalData.actionButtonText">
            <button *ngIf="modalData.actions"  class="btn-stroked buttons-secondary modal-buttons"  (click)="closeModal()">
                {{modalData.actionButtonText}}
            </button>
        </footer>
    </div>
    </div>
</ng-template>
